export default class DarkSections {
	constructor() {
		this.darkBGs = document.querySelectorAll(".has-dark-bg") || false;
		this.brandelementRect = document
			.querySelector(".brand")
			.getBoundingClientRect();
		this.offset = this.brandelementRect.top + this.brandelementRect.height;
		this.init();
		this.events();
	}

	init() {}

	events() {
		if (this.darkBGs) {
			if (window.Scrollbar) {
				let scrollTimeout;
				window.Scrollbar.addListener((status) => {
					if (scrollTimeout) {
						window.clearTimeout(scrollTimeout);
					}

					scrollTimeout = window.setTimeout(() => {
						Array.prototype.slice.call(this.darkBGs).forEach((section) => {
							const sectionRect = section.getBoundingClientRect();

							if (
								(sectionRect.top > 0 &&
									sectionRect.top < window.innerHeight / 3) ||
								(sectionRect.bottom > 0 &&
									sectionRect.bottom < window.innerHeight / 3)
							) {
								if (
									sectionRect.top <= this.offset &&
									sectionRect.y + sectionRect.height > this.offset
								) {
									document.body.classList.add("scrolling-on-dark-section");
								} else {
									document.body.classList.remove("scrolling-on-dark-section");
								}
							}
						});
					}, 5);
				});
			} else {
				let scrollTimeout;
				window.addEventListener("scroll", (ev) => {
					if (scrollTimeout) {
						window.clearTimeout(scrollTimeout);
					}

					scrollTimeout = window.setTimeout(() => {
						Array.prototype.slice.call(this.darkBGs).forEach((section) => {
							const sectionRect = section.getBoundingClientRect();

							if (
								(sectionRect.top > 0 &&
									sectionRect.top < window.innerHeight / 3) ||
								(sectionRect.bottom > 0 &&
									sectionRect.bottom < window.innerHeight / 3)
							) {
								if (
									sectionRect.top <= this.offset &&
									sectionRect.y + sectionRect.height > this.offset
								) {
									document.body.classList.add("scrolling-on-dark-section");
								} else {
									document.body.classList.remove("scrolling-on-dark-section");
								}
							}
						});
					}, 5);
				});
			}
		}
	}
}
